import React, { useEffect, useState } from 'react';
import { listarUsuarios, crearUsuario, editarUsuario, desactivarUsuario, eliminarUsuarioTotal } from '../../services/userService';
import { Table, Button, Form, Modal, Badge } from 'react-bootstrap';
import { nivelesSuscripcion } from '../../data/suscripcionLevels';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export const ABMUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [userDataVersion, setUserDataVersion] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    uid: '',
    email: '',
    displayName: '',
    nivelSuscripcion: 0,
    isActive: true
  });
  const [editMode, setEditMode] = useState(false);

  const fetchUsuarios = async () => {
    const data = await listarUsuarios();
    setUsuarios(data.usuarios || []);
    setUserDataVersion(data.userDataVersion || '');
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const handleShowModal = (usuario = null) => {
    if (usuario) {
      setFormData(usuario);
      setEditMode(true);
    } else {
      setFormData({
        uid: '',
        email: '',
        displayName: '',
        nivelSuscripcion: 0,
        isActive: true
      });
      setEditMode(false);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'nivelSuscripcion') {
      setFormData(prev => ({ ...prev, nivelSuscripcion: Number(value) }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // El rol será igual al nombre del nivel seleccionado
    const nivel = nivelesSuscripcion.find(n => n.id === Number(formData.nivelSuscripcion));
    const dataToSave = {
      ...formData,
      roles: [nivel ? nivel.nombre : 'free']
    };
    if (editMode) {
      await editarUsuario(formData.uid, dataToSave);
    } else {
      await crearUsuario(dataToSave);
    }
    fetchUsuarios();
    handleCloseModal();
  };

  const handleDesactivar = async (uid) => {
    await desactivarUsuario(uid);
    fetchUsuarios();
  };

  const handleActivar = async (uid) => {
    await desactivarUsuario(uid, true);
    fetchUsuarios();
  };

  const handleEliminar = async (uid) => {
    const result = await MySwal.fire({
      title: '¿Estás seguro?',
      text: '¿Estás seguro de que deseas eliminar este usuario? Esta acción es irreversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        await eliminarUsuarioTotal(uid);
        MySwal.fire({
          title: '¡Éxito!',
          text: 'Usuario eliminado correctamente',
          icon: 'success'
        });
        fetchUsuarios();
      } catch (error) {
        MySwal.fire({
          title: 'Error',
          text: 'Error al eliminar usuario: ' + error.message,
          icon: 'error'
        });
      }
    }
  };

  return (
    <div className="container mt-4">
      <h2>Gestión de Usuarios</h2>
      <div className="mb-2 text-muted" style={{ fontSize: '0.9em' }}>
        <strong>Versión datos usuario:</strong> {userDataVersion}
      </div>
      <Button className="mb-3" onClick={() => handleShowModal()}>Crear Usuario</Button>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Email</th>
            <th>Nombre</th>
            <th>Nivel</th>
            <th>Roles</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map(user => (
            <tr key={user.uid}>
              <td>{user.email}</td>
              <td>{user.displayName}</td>
              <td>{user.nivelSuscripcion}</td>
              <td>{user.roles && user.roles.map(r => <Badge bg="info" key={r}>{r}</Badge>)}</td>
              <td>{user.isActive ? <Badge bg="success">Activo</Badge> : <Badge bg="secondary">Inactivo</Badge>}</td>
              <td>
                <Button size="sm" variant="warning" onClick={() => handleShowModal(user)}>Editar</Button>{' '}
                {user.isActive ? (
                  <Button size="sm" variant="secondary" onClick={() => handleDesactivar(user.uid)}>Desactivar</Button>
                ) : (
                  <Button size="sm" variant="success" onClick={() => handleActivar(user.uid)}>Activar</Button>
                )}
                {' '}
                <Button size="sm" variant="danger" onClick={() => handleEliminar(user.uid)}>Eliminar</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? 'Editar Usuario' : 'Crear Usuario'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control name="email" value={formData.email} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Nivel de Suscripción</Form.Label>
              <Form.Select name="nivelSuscripcion" value={formData.nivelSuscripcion} onChange={handleChange}>
                {nivelesSuscripcion.map(nivel => (
                  <option key={nivel.id} value={nivel.id}>{nivel.nombre}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Button type="submit">{editMode ? 'Guardar Cambios' : 'Crear Usuario'}</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}; 